<template>
    <!--  故障详情 -->
    <a-modal
    centered
    :title="title"
    :visible="visible"
    :width="720"
    :destroyOnClose="true"
    @cancel="close"
    :footer="false"
    dialogClass="fault-detail-modal"
    >
        <a-spin :spinning="loading">
            <a-tabs type="card" default-active-key="1">
                <a-tab-pane key="1" tab="当前故障">
                    <template v-if="level !== 'ok'">
                        <div class="font-big text-color-85 mb16">基础信息</div>
                        <a-row class="mb16 text-color-45">
                            <a-col :span="12">{{ title }}</a-col>
                            <a-col :span="12">告警级别：{{ currentWarn.level | monitorState }}</a-col>
                        </a-row>
                        <a-row class="mb16 text-color-45">
                            <a-col :span="12">告警时间：{{ currentWarn.effectiveStart }}</a-col>
                            <a-col :span="12">持续时长：{{ currentWarn.effectiveDuration | SEC2DHM }}</a-col>
                        </a-row>
                        <div class="font-big text-color-85 mb16">故障原因</div>
                        <pre class="text-color-45 mb16" style="white-space: pre-wrap;">{{ currentWarn.description | isEmpty }}</pre>
                        <div class="font-big text-color-85 mb16">处置流程</div>
                        <pre class="text-color-45" style="white-space: pre-wrap;">{{ currentWarn.fixDescription | isEmpty }}</pre>
                    </template>
                    <template v-else>
                        <div class="pb24 pt24 pl24 pr24 bg-white">
                            <div class="text-center operation-empty pt80 pb80">
                                <img width="222" src="../../../assets/image/operation-empty.png" alt="">
                                <div class="mt24" style="color: #babcc2; font-size: 24px;">暂无数据</div>
                            </div>
                        </div>
                    </template>
                </a-tab-pane>
                <a-tab-pane key="2" tab="历史故障" force-render>
                    <a-form :form="form">
                        <a-row>
                            <a-col :span="13">
                                <a-form-item class="mb16" label="告警日期" :label-col="{span: 6}" :wrapper-col="{span: 18}">
                                    <a-range-picker style="width: 100%;" v-decorator="['dateRange']" format="YYYY.MM.DD">
                                        <template slot="suffixIcon">
                                            <a-icon type="calendar" />
                                        </template>
                                    </a-range-picker>
                                </a-form-item>
                            </a-col>
                            <a-col class="text-right" :span="11">
                                <a-button type="primary" @click="search">筛选</a-button>
                                <a-button @click="reset">重置</a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                    <a-table
                        bordered
                        size="middle"
                        :columns="columns"
                        :data-source="dataSource"
                        :pagination="pagination"
                        @change="changePage"
                        :rowKey="item => item.problemId"
                    >
                        <template slot="effectiveDuration" slot-scope="key, row, index">
                            {{key | SEC2DHM}}
                        </template>
                        <template slot="isEmpty" slot-scope="key, row, index">
                            <pre style="white-space: pre-wrap;">{{key | isEmpty}}</pre>
                        </template>
                    </a-table>
                </a-tab-pane>
            </a-tabs>
        </a-spin>
    </a-modal>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "FaultDetailModal",
        components: {
        },
        data() {
            const columns = [
                {
                    title: '告警时间',
                    dataIndex: 'effectiveStart',
                    width: 180
                },
                {
                    title: '持续时长',
                    dataIndex: 'effectiveDuration',
                    scopedSlots: {customRender: 'effectiveDuration'},
                    width: 160
                },
                {
                    title: '告警原因',
                    dataIndex: 'description',
                    scopedSlots: {customRender: 'isEmpty'}
                },

            ];
            return {
                columns,
                dataSource: [],
                visible: false,
                loading: false,
                title: '',
                nodeId: null,
                level: 'ok',
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: false,
                    showQuickJumper: false,
                    total: 0,
                    current: 1,
                    pageSize: 5
                },
                currentWarn: {}
            }
        },
        computed: {
            ...mapGetters(["shopId", 'shopName'])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            open({title, nodeId, level}) {
                this.title = '监控项：' + title;
                this.nodeId = nodeId;
                this.level = level;
                this.visible = true;
                setTimeout(() => {
                    this.search();
                }, 200)
            },
            close() {
                this.visible = false;
            },
            search() {
                if (this.loading) {
                    return false;
                }
                this.pagination.current = 1;
                this.queryProblem();
            },
            reset() {
                this.form.resetFields();
                this.search();
            },
            /**
             * @queryProblem {method} 分页查询故障。
             */
            queryProblem() {
                if ((!Boolean(this.shopId) || String(this.shopId) === '-1') && !Boolean(this.$route.query.shopId) || !Boolean(this.nodeId) || this.loading) {
                    return false;
                }
                this.form.validateFields((errors, values) => {
                    this.loading = true;
                    this.$api.operationManagement.queryProblem({
                        body: {
                            nodeId: this.nodeId,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.$route.query.shopId ? this.$route.query.shopId : this.shopId,
                            dateBefore: Boolean(values.dateRange) && Boolean(values.dateRange[1]) ? values.dateRange[1].format('YYYY-MM-DD') : undefined,
                            dateAfter: Boolean(values.dateRange) && Boolean(values.dateRange[0]) ? values.dateRange[0].format('YYYY-MM-DD') : undefined
                        }
                    }).then(res => {
                        this.loading = false;
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                        if (Boolean(values.dateRange) || !this.pagination.current === 1 || res.list.length === 0) {
                            return false;
                        }
                        this.currentWarn = res.list[0];

                    });
                });
            },
            changePage(page) {
                if (this.loading) {
                    return false;
                }
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.queryProblem();
            },
        }
    };
</script>

<style lang="scss">
.fault-detail-modal {
    .operation-empty {
        background: #fafafa;
        border: 1px solid #e9e9e9;
    }
}
</style>
